import React, { useEffect, useRef, useState} from 'react'
import styles from './FieldSystemPage.module.css'
import {
    AppBar,
    Button,
} from '@material-ui/core'
import Typography from '@mui/material/Typography'
import cn from 'classnames'
import axios from "axios";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import {getConfig} from "../../AppConfig";
import {useForm} from "react-hook-form";
import {Alert, Container, Grid, IconButton, Toolbar} from "@mui/material";
import {useParams} from "react-router";
import Box from "@mui/material/Box";
import CalendarPage from "./Calendar/CalendarPage";
import DeleteIcon from "@mui/icons-material/Delete";
import {ArrowBackIos} from "@mui/icons-material";
import VacationPage from "./Vacation/VacationPage";
import EmergencyPage from "./Emergency/EmergencyPage";
import DocumentsPage from "./Documents/DocumentsPage";
import {ifElse} from "@progress/kendo-data-query/dist/npm/funcs";
import CompanyFormsPage from "./CompanyForms/CompanyFormsPage";
import {useHistory} from "react-router-dom";
import WorkReportingTemplates from "./WorkReporting/WorkReportingTemplates";
import { jwtDecode } from "jwt-decode";
import UnsavedDocuments from "./UnsavedDocuments/UnsavedDocuments";
import TimeEntryPage from "./Time/TimeEntryPage";

interface Params {
    userGuid: string
}

interface FormData {
    phone: string
}

export const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/

const MainPage = () => {
    const history = useHistory()
    const formMethods = useForm<FormData>()
    const { userGuid } = useParams<Params>()
    const { fieldappversion, workreportingappversion } = getConfig()
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [title, setTitle] = React.useState('')
    const [subTitle, setSubTitle] = React.useState('')
    const [showFieldSystemMainApp, setShowFieldSystemMainApp] = React.useState(true)
    const [showDocuments, setShowDocuments] = React.useState(false)
    const [showCalendar, setShowCalendar] = React.useState(false)
    const [showVacation, setShowVacation] = React.useState(false)
    const [showEmergency, setShowEmergency] = React.useState(false)
    const [showCompanyForms, setShowCompanyForms] = React.useState(false)
    const [showWorkReporting, setShowWorkReporting] = React.useState(false)
    const [showUnsavedDocuments, setShowUnsavedDocuments] = React.useState(false)
    const [showTime, setShowTime] = React.useState(false)
    const [backArrow, setBackArrow] = React.useState('main')
    const [backArrowClick, setBackArrowClick] = React.useState(1)
    const [displayFileViewer, setDisplayFileViewer] = React.useState(false)
    const [displayTimeEntry, setDisplayTimeEntry] = React.useState(false)
    const [displayCrew, setDisplayCrew] = React.useState(false)
    const [displayEmployee, setDisplayEmployee] = React.useState(false)
    const [displayHistory, setDisplayHistory] = React.useState(false)
    const [systemVersion, setSystemVersion] = React.useState()
    const [fieldSystemData, setFieldSystemData] = React.useState(
        {
            company: '',
            employee: '',
            showbuttondocument: true,
            showbuttoncalendar: true,
            showbuttonemergency: true,
            showbuttonform: true,
            showbuttontemplate: true,
            showbuttonvacation: true,
            showbuttontime: true,
        })

    useEffect(() => {
        getToken()
    }, [])

    useEffect(() => {
        if (showFieldSystemMainApp) {
            setSubTitle('')
        }
        else {
            setSubTitle(fieldSystemData?.company + ' - ' + fieldSystemData?.employee)
        }
    }, [showFieldSystemMainApp])

    const versionCompare = (v1, v2) => {
        const parts1 = v1.split('.').map(Number);
        const parts2 = v2.split('.').map(Number);

        for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
            const p1 = parts1[i] || 0; // Default to 0 if part is missing
            const p2 = parts2[i] || 0; // Default to 0 if part is missing

            if (p1 > p2) return 1; // v1 is greater
            if (p1 < p2) return -1; // v2 is greater
        }

        return 0; // versions are equal
    }

    const getToken = () => {
        setLoadingBackdrop(true)
        const body = {}
        axios.post(`fieldsystemtoken/` + userGuid, body).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            if (parsedResponse?.status == 'failure') {
                setLoadingBackdrop(false)

                setSnackbarOpen({ open: true, message: parsedResponse.message  });
                history.push('/')
            }
            else {
                localStorage.setItem('token', parsedResponse.token)

                if (parsedResponse.token) {
                    const decoded: any = jwtDecode(parsedResponse.token)
                    setSystemVersion(decoded.systemversion)
                }
                getFieldSystemData()
            }
        }).catch(error => {
            console.log(error)
            if (error.response?.status === 401) {
                setSnackbarOpen({ open: true, message: error?.response?.data?.title });
                history.push('/')
            }
            else if (error.response) {
                setSnackbarOpen({ open: true, message: error?.response?.data?.title  });
            } else if (error.request) {
                setSnackbarOpen({ open: true, message: error.request  });
            } else {
                setSnackbarOpen({ open: true, message: error.message  });
            }

            setLoadingBackdrop(false)
        })
    }

    const getFieldSystemData = () => {
        axios.get(`fieldsystem`).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            console.log(parsedResponse)
            setLoadingBackdrop(false)
            setFieldSystemData(parsedResponse)
        })
    }
    const onSubmit = async (data: FormData) => {
        setLoadingBackdrop(true)
        const body = {
            phone: data.phone
        }

        axios.post(`fieldsystemphone`, body).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            setLoadingBackdrop(false)
            setSnackbarOpen( { open: true, message: parsedResponse.message})
        })
    }

    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    const handleBackArrow = (type) => {
        if (type === 'document') {
            setShowFieldSystemMainApp(false)
            setShowDocuments(true)
            setShowCalendar(false)
            setShowVacation(false)
            setShowEmergency(false)
            setShowCompanyForms(false)
            setShowWorkReporting(false)
            setShowUnsavedDocuments(false)
            setShowTime(false)
        }
        else if (type === 'calendar') {
            setShowFieldSystemMainApp(false)
            setShowDocuments(false)
            setShowCalendar(true)
            setShowVacation(false)
            setShowEmergency(false)
            setShowCompanyForms(false)
            setShowWorkReporting(false)
            setShowUnsavedDocuments(false)
            setShowTime(false)
        }
        else if (type === 'vacation') {
            setShowFieldSystemMainApp(false)
            setShowDocuments(false)
            setShowCalendar(false)
            setShowVacation(true)
            setShowEmergency(false)
            setShowCompanyForms(false)
            setShowWorkReporting(false)
            setShowUnsavedDocuments(false)
            setShowTime(false)
        }
        else if (type === 'emergency') {
            setShowFieldSystemMainApp(false)
            setShowDocuments(false)
            setShowCalendar(false)
            setShowVacation(false)
            setShowEmergency(true)
            setShowCompanyForms(false)
            setShowWorkReporting(false)
            setShowUnsavedDocuments(false)
            setShowTime(false)
        }
        else if (type === 'main') {
            setShowFieldSystemMainApp(true)
            setShowDocuments(false)
            setShowCalendar(false)
            setShowVacation(false)
            setShowEmergency(false)
            setShowCompanyForms(false)
            setShowWorkReporting(false)
            setShowUnsavedDocuments(false)
            setShowTime(false)
        }
        else if (type === 'companyforms') {
            setShowFieldSystemMainApp(false)
            setShowDocuments(false)
            setShowCalendar(false)
            setShowVacation(false)
            setShowEmergency(false)
            setShowCompanyForms(true)
            setShowWorkReporting(false)
            setShowUnsavedDocuments(false)
            setShowTime(false)
        }
        else if (type === 'workreporting') {
            setShowFieldSystemMainApp(false)
            setShowDocuments(false)
            setShowCalendar(false)
            setShowVacation(false)
            setShowEmergency(false)
            setShowCompanyForms(false)
            setShowWorkReporting(true)
            setShowUnsavedDocuments(false)
            setShowTime(false)
        }
        else if (type === 'unsaveddocuments') {
            setShowFieldSystemMainApp(false)
            setShowDocuments(false)
            setShowCalendar(false)
            setShowVacation(false)
            setShowEmergency(false)
            setShowCompanyForms(false)
            setShowWorkReporting(false)
            setShowUnsavedDocuments(true)
            setShowTime(false)
        }
        else if (type === 'timeentry') {
            setShowFieldSystemMainApp(false)
            setShowDocuments(false)
            setShowCalendar(false)
            setShowVacation(false)
            setShowEmergency(false)
            setShowCompanyForms(false)
            setShowWorkReporting(false)
            setShowUnsavedDocuments(false)
            setShowTime(true)
        }
    }

    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="success">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <>
                <AppBar position="absolute" className={cn(styles.appBar, styles.shift)} >
                    {/*{!showFieldSystemMainApp &&*/}
                    {/*    <Toolbar style={{display: 'inline-block', paddingLeft: '4px',*/}
                    {/*        paddingRight: '4px'}}>*/}
                    {/*        <IconButton sx={{ marginRight: "auto" }} onClick={() => {*/}
                    {/*            setShowFieldSystemMainApp(true)*/}
                    {/*            setShowCalendar(false)*/}
                    {/*        }} aria-label="back" color="primary">*/}
                    {/*            <ArrowBackIos />*/}
                    {/*        </IconButton>*/}
                    {/*        <Typography style={{display: 'inline-block', border: '10px solid red'}} variant="h6" color="primary" component="div" align="center">*/}

                    {/*            {showFieldSystemMainApp ? 'Alvah Group Field System ' : 'Alvah Group Field System - ' + title}*/}
                    {/*            <Typography textAlign="right" fontSize={'11px'} style={{display: 'inline-block', paddingLeft: '2px'}} variant="caption" color="textDisabled" component="div" >*/}
                    {/*                {fieldappversion}*/}
                    {/*            </Typography>*/}
                    {/*        </Typography>*/}
                    {/*    </Toolbar>*/}
                    {/*}*/}
                    <Typography style={{display: 'inline-block'}} variant="h6" color="primary" component="div" align="center">
                        {!showFieldSystemMainApp &&
                            <IconButton sx={{ marginRight: "auto" }} onClick={() => {
                                setBackArrowClick(backArrowClick+1)
                                if (!displayFileViewer) {
                                    handleBackArrow(backArrow)
                                }
                                else if (!displayTimeEntry) {
                                    handleBackArrow(backArrow)
                                }
                                else if (!displayCrew) {
                                    handleBackArrow(backArrow)
                                }
                                else if (!displayEmployee) {
                                    handleBackArrow(backArrow)
                                }

                            }} aria-label="back" color="primary">
                                <ArrowBackIos />
                            </IconButton>
                        }
                        {showFieldSystemMainApp ? 'Alvah Group Field System ' : 'Alvah Group Field System - ' + title}
                        <Typography textAlign="right" fontSize={'11px'} style={{display: 'inline-block', paddingLeft: '2px'}} variant="caption" color="textDisabled" component="div" >
                            {fieldappversion}
                        </Typography>
                        <Typography variant="subtitle2" color="primary" component="div" align="center" >
                            {subTitle}
                        </Typography>
                        {systemVersion && versionCompare(systemVersion, workreportingappversion) == 1 &&
                            <div style={{color: "red", textAlign: 'center', margin: '10px'}}> {'Current system version ' + workreportingappversion + ' latest version ' + systemVersion + ' Please update.'}</div>
                        }
                    </Typography>
                </AppBar>
                {showDocuments &&
                    <div style={{marginTop: 60}}>
                        <DocumentsPage
                            setTitle={setTitle}
                            setSubTitle={setSubTitle}
                            setBackArrow={setBackArrow}
                            backArrowClick={backArrowClick}
                            displayFileViewer={displayFileViewer}
                            setDisplayFileViewer={setDisplayFileViewer}
                        />
                    </div>
                }
                {showCalendar &&
                    <div style={{marginTop: 60}}>
                        <CalendarPage setTitle={setTitle} setSubTitle={setSubTitle}/>
                    </div>
                }
                {showVacation &&
                    <div style={{marginTop: 60}}>
                        <VacationPage setTitle={setTitle} setSubTitle={setSubTitle} handleBackArrow={handleBackArrow} />
                    </div>
                }
                {showEmergency &&
                    <div style={{marginTop: 60}}>
                        <EmergencyPage setTitle={setTitle} setSubTitle={setSubTitle} handleBackArrow={handleBackArrow} />
                    </div>
                }
                {showCompanyForms &&
                    <div style={{marginTop: 60}}>
                        <CompanyFormsPage setTitle={setTitle} setSubTitle={setSubTitle} />
                    </div>
                }
                {showWorkReporting &&
                    <div style={{marginTop: 60}}>
                        <WorkReportingTemplates setTitle={setTitle} setSubTitle={setSubTitle} />
                    </div>
                }
                {showUnsavedDocuments &&
                    <div style={{marginTop: 60}}>
                        <UnsavedDocuments setTitle={setTitle} setSubTitle={setSubTitle} />
                    </div>
                }
                {showTime &&
                    <div style={{marginTop: 60}}>
                        <TimeEntryPage
                            setTitle={setTitle}
                            setSubTitle={setSubTitle}
                            setBackArrow={setBackArrow}
                            backArrowClick={backArrowClick}
                            displayTimeEntry={displayTimeEntry}
                            setDisplayTimeEntry={setDisplayTimeEntry}
                            displayCrew={displayCrew}
                            setDisplayCrew={setDisplayCrew}
                            displayEmployee={displayEmployee}
                            setDisplayEmployee={setDisplayEmployee}
                            userGuid={userGuid}
                        />
                    </div>
                }
                {showFieldSystemMainApp &&
                    <div style={{display: loadingBackdrop ? 'none' : 'inline-flex', marginTop: '40px'}}>
                        <Container>
                            <Box>
                                <Grid
                                    container
                                    border={0}
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                    // height={'100%'}
                                    // width={'100%'}
                                >
                                    <>
                                        <Grid item border={0} marginLeft={2} md={4} xs={4}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'left',
                                            }}
                                            >
                                                <Typography variant="body2" gutterBottom>
                                                    {'Company:'}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item border={0} marginRight={2} md={4} xs={4}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'left',
                                            }}
                                            >
                                                <Typography variant="body2" gutterBottom>
                                                    {fieldSystemData.company}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item border={0} marginLeft={2} md={4} xs={4}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'left',
                                            }}
                                            >
                                            <Typography variant="body2" gutterBottom>
                                                {'Employee:'}
                                            </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item border={0} marginRight={2} md={4} xs={4}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', md: 'row' },
                                                alignItems: 'center',
                                                justifyContent: 'left',
                                            }}
                                            >
                                                <Typography variant="body2" gutterBottom>
                                                    {fieldSystemData.employee}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        {fieldSystemData?.showbuttondocument &&
                                            <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                    <Button onClick={() => {
                                                        handleBackArrow('document')
                                                    }}
                                                        color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Access Edit WO Documents</Button>
                                                </Box>
                                            </Grid>
                                        }
                                        {fieldSystemData?.showbuttontemplate &&
                                            <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                    <Button onClick={() => { handleBackArrow('workreporting') }} color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Work Reporting Template</Button>
                                                </Box>
                                            </Grid>
                                        }
                                        {fieldSystemData?.showbuttonform &&
                                            <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                    <Button onClick={() => {
                                                        handleBackArrow('companyforms')
                                                    }} color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">General Forms</Button>
                                                </Box>
                                            </Grid>
                                        }
                                        {fieldSystemData?.showbuttonemergency &&
                                            <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                    <Button onClick={() => {
                                                        handleBackArrow('emergency')
                                                    }}  color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Create Emergency Work Order</Button>
                                                </Box>
                                            </Grid>
                                        }
                                        {fieldSystemData?.showbuttonvacation &&
                                            <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                    <Button onClick={() => {
                                                        handleBackArrow('vacation')
                                                    }} color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Vacation</Button>
                                                </Box>
                                            </Grid>
                                        }
                                        {fieldSystemData?.showbuttoncalendar &&
                                            <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                    <Button onClick={() => {
                                                        handleBackArrow('calendar')
                                                    }} color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Calendar</Button>
                                                </Box>
                                            </Grid>
                                        }
                                        {fieldSystemData?.showbuttonform &&
                                            <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                    <Button onClick={() => {
                                                        handleBackArrow('unsaveddocuments')
                                                    }} color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">In Progress</Button>
                                                </Box>
                                            </Grid>
                                        }
                                        {fieldSystemData?.showbuttontime &&
                                            <Grid item border={0} alignItems={'center'} alignContent={'center'} justifyContent="center" md={8} xs={12}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                >
                                                    <Button onClick={() => {
                                                        handleBackArrow('timeentry')
                                                    }} color="primary" style={{width: '100%', marginTop: '10px'}}  variant="contained">Time Clock</Button>
                                                </Box>
                                            </Grid>
                                        }
                                    </>
                                </Grid>
                            </Box>
                        </Container>
                    </div>
                }

            </>
        </div>
    )
}

export default MainPage